import { Directive, Input, OnInit } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsDataChangeService } from '@icms/core/data/change/icms-data-change.service';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { PageHeaderService } from '../../../layout/page/header/page-header.service';

@Directive()
export class PageViewAbstract extends UiComponent implements OnInit {
    @Input()
    model?: ICmsPage<IPageDataV3>;

    constructor(
        protected iCmsDataChangeService: ICmsDataChangeService,
        private pageHeaderService: PageHeaderService,
    ) {
        super();
    }

    override ngOnInit() {
        this.subscriptions.add(
            this.iCmsDataChangeService.afterChange$.subscribe(event => {
                const parentPath = ['data', 'parent'];
                if (event.model === this.model && this.iCmsDataChangeService.filterByData(event, this.model.type, [parentPath])) {
                    this.detectChanges();
                }
            })
        );
        super.ngOnInit();
    }

    override detectChanges() {
        this.updateClassNames();
        super.detectChanges();
    }

    protected updateClassNames(): void {
        this.pageHeaderService.setHighPriorityState({
            transparent: this.transparent,
            lightMode: this.lightMode,
            hideUp: this.hideUp
        });
    }

    protected get transparent(): boolean {
        return !!this.model?.data?.additional?.headerTransparent;
    }

    protected get lightMode(): boolean {
        return !!this.model?.data?.additional?.headerLightMode;
    }

    protected get hideUp(): boolean {
        return !!this.model?.data?.additional?.headerHideUp;
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        // reset page header settings
        this.timeoutService.platformSafe(() => this.pageHeaderService.resetHighPriorityState()); // injector may be destroyed
    }
}
